
const { WTN } = window as any;

export const isWebToNativeDevice = async (): Promise<boolean> => {

  if (typeof WTN === "undefined") return false

  try {

    const deviceInfo = await WTN.deviceInfo();

    return !!deviceInfo
  } catch (error) {

    return false
  }
}

export const isAndroid = async (): Promise<boolean> => {

  try {
    const deviceInfo = await WTN.deviceInfo()

    return deviceInfo.platform === 'android'
  } catch (error) {

    return false
  }
}

export const isIOS = async (): Promise<boolean> => {

  try {
    const deviceInfo = await WTN.deviceInfo()

    return deviceInfo.platform === 'ios'
  } catch (error) {

    return false
  }
}
